
function embedYouTubeLinks(html) {
    if (!html) return '';
    // קודם נטפל ב<a href=...> עם t
    html = html.replace(
        /<a[^>]+href="(https:\/\/(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)(?:[&?]t=(\d+))?[^"]*)"[^>]*>[^<]*<\/a>|<a[^>]+href="(https:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(?:\?t=(\d+))?)"[^>]*>[^<]*<\/a>/g,
        (match, p1, id1, t1, p2, id2, t2) => {
            const videoId = id1 || id2;
            const start = t1 || t2;
            const startParam = start ? `?start=${start}` : '';
            return `<div class="youtube-container" style="aspect-ratio: 16/9; margin: 2rem 0;">
        <iframe
          src="https://www.youtube.com/embed/${videoId}${startParam}"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          style="width: 100%; height: 100%; border-radius: 16px"
        ></iframe>
      </div>`;
        }
    );
    // אחר כך נטפל גם בטקסט נקי של קישור עם t
    html = html.replace(
        /(https:\/\/(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)(?:[&?]t=(\d+))?)|(https:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(?:\?t=(\d+))?)/g,
        (match, p1, id1, t1, p2, id2, t2) => {
            const videoId = id1 || id2;
            const start = t1 || t2;
            const startParam = start ? `?start=${start}` : '';
            return `<div class="youtube-container" style="aspect-ratio: 16/9; margin: 2rem 0;">
        <iframe
          src="https://www.youtube.com/embed/${videoId}${startParam}"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          style="width: 100%; height: 100%; border-radius: 16px"
        ></iframe>
      </div>`;
        }
    );
    return html;
}

function autoLinkify(html) {
    // הופך כל כתובת https://... ל<a href="...">...</a> (רק אם היא לא כבר בתוך a)
    return html.replace(
        /(?<!["'>])\b(https?:\/\/[^\s<]+)/g,
        (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
}

export function embedMedia(html) {
    if (!html) return '';

    // 1. יוטיוב (כבר יש לך)
    html = embedYouTubeLinks(html);

    html = autoLinkify(html);

    // 2. תמונות: קישור בתוך a
    html = html.replace(
        /<a[^>]+href="(https?:\/\/[^\s"]+\.(?:png|jpe?g|gif|webp|svg))"[^>]*>[^<]*<\/a>/gi,
        (match, url) => {
            return `<div style="display:flex;justify-content:center;margin:2rem 0;">
                <img src="${url}" alt="תמונה מוטמעת" style="max-width:100%;border-radius:18px;box-shadow:0 4px 16px #ddd"/>
            </div>`;
        }
    );
    // 3. כתובת נטו של תמונה (לא בתור קישור)
    html = html.replace(
        /(https?:\/\/[^\s<"]+\.(?:png|jpe?g|gif|webp|svg))/gi,
        (url) => {
            return `<div style="display:flex;justify-content:center;margin:2rem 0;">
                <img src="${url}" alt="תמונה מוטמעת" style="max-width:100%;border-radius:18px;box-shadow:0 4px 16px #ddd"/>
            </div>`;
        }
    );

    return html;
}